import { useState } from 'react';
import * as http from '../../../../../utils/http';
import { ConsultationDoctor } from 'data-types';



interface UseConsultationBookingParams {
	country: string;
	providerType?: 'doctor' | 'nutritionist';
}

interface BookPayload {
	doctorID?: number;
	providerType?: 'doctor' | 'nutritionist';
	providerID?: number;
	start: string;
	end: string;
}

export const useConsultationBooking = ({ country, providerType = 'doctor' }: UseConsultationBookingParams) => {
	const [doctors, setDoctors] = useState<ConsultationDoctor[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [booking, setBooking] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	const loadAvailability = () => {
		setLoading(true);
		setError(null);

		const queryParam = providerType !== 'doctor' ? `?providerType=${providerType}` : '';
		http
			.getFromServer(`${country}/account/care-profile/consultation/availability${queryParam}`, [http.MIDDLEWARES.CUSTOMER_ID])
			.then((response: any) => {
				setDoctors(response.data?.doctors ?? []);
			})
			.catch((err: any) => {
				window.clientLogger.error('Error in useConsultationBooking.loadAvailability: ', err);
				setError('load');
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const book = (payload: BookPayload, onSuccess: () => void) => {
		setBooking(true);
		setError(null);

		http
			.postToServer(`${country}/account/care-profile/consultation/book`, payload, [http.MIDDLEWARES.CUSTOMER_ID])
			.then(() => {
				onSuccess();
			})
			.catch((err: any) => {
				window.clientLogger.error('Error in useConsultationBooking.book: ', err);
				setError(err?.response?.data?.message || 'book');
			})
			.finally(() => {
				setBooking(false);
			});
	};

	return { doctors, loading, booking, error, loadAvailability, book };
};
